import { useState } from 'react';
import { signInWithGoogle } from '@/lib/auth';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

export default function LoginPage() {
  const [busy, setBusy] = useState(false);
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="w-full max-w-sm border border-border rounded-lg p-6 space-y-4">
        <div className="text-center space-y-1">
          <h1 className="text-2xl font-bold">CHER Bot</h1>
          <p className="text-sm text-muted-foreground">Admin Dashboard</p>
        </div>
        <p className="text-xs text-muted-foreground text-center">
          ต้อง login ด้วย Google account ที่อยู่ใน admin allowlist
        </p>
        <Button
          className="w-full btn-cta-primary"
          disabled={busy}
          onClick={async () => {
            setBusy(true);
            try {
              await signInWithGoogle();
            } catch (e) {
              toast.error(`Login failed: ${(e as Error).message}`);
              setBusy(false);
            }
          }}
        >
          {busy ? 'กำลัง redirect...' : 'Sign in with Google'}
        </Button>
        <p className="text-xs text-muted-foreground text-center">
          พบปัญหา? ติดต่อ Gammy
        </p>
      </div>
    </div>
  );
}
